module.exports = __webpack_public_path__ + "static/How-Do-I-Progress_09-24-c739e8258d0faed5a63845f423ad5583.pdf";